module.exports = {
          srcSet: __webpack_public_path__ + "assets/d28db9accd5d1d99c2de36336be61d86.jpg"+" 84w",
          images:[ {path: __webpack_public_path__ + "assets/d28db9accd5d1d99c2de36336be61d86.jpg",width: 84,height: 84}],
          src: __webpack_public_path__ + "assets/d28db9accd5d1d99c2de36336be61d86.jpg",
          toString:function(){return __webpack_public_path__ + "assets/d28db9accd5d1d99c2de36336be61d86.jpg"},
          
          width: 84,
          height: 84
        }